export const KEY_TO_NAME = {
  SP3: 'SongPop 3',
};
